class Settings
{
  constructor()
  {
    this.rf_sim_ws_url = 'ws://127.0.0.1:8765';
    this.snr_bars = 40;
    this.noise_height = 100;
    this.noise_max = 0;
    this.noise_min = -40;
  }
}

const settings = new Settings();
export { settings as Settings };
